/**
 * @generated SignedSource<<5f05c2d705537e3f2778e8e1e285900c>>
 * @relayHash 363ade6512b153bfec3514dc3eb03201
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 51a26fa687033043eb07c146c0ff46b6504a66546ab2ef327ff9f8908542826b

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActorType = "GUILDS" | "USERS" | "%future added value";
export type EventVisibility = "LISTED" | "UNLISTED" | "%future added value";
export type UpdateEventByIdInput = {
  clientMutationId?: string | null | undefined;
  id: string;
  patch: EventPatch;
};
export type EventPatch = {
  allowGlobalListing?: boolean | null | undefined;
  attendeeLimit?: number | null | undefined;
  coverPhotoId?: string | null | undefined;
  createdAt?: string | null | undefined;
  description?: string | null | undefined;
  endAt?: string | null | undefined;
  eventSeriesId?: string | null | undefined;
  externalUrl?: string | null | undefined;
  metadata?: any | null | undefined;
  name?: string | null | undefined;
  ownerId?: string | null | undefined;
  ownerType?: ActorType | null | undefined;
  rowId?: string | null | undefined;
  slug?: string | null | undefined;
  startAt?: string | null | undefined;
  timeZone?: string | null | undefined;
  updatedAt?: string | null | undefined;
  venueId?: string | null | undefined;
  visibility?: EventVisibility | null | undefined;
};
export type EventScreenSettingsButtonUpdateMutation$variables = {
  input: UpdateEventByIdInput;
};
export type EventScreenSettingsButtonUpdateMutation$data = {
  readonly updateEventById: {
    readonly event: {
      readonly " $fragmentSpreads": FragmentRefs<"EventScreenNewDesktop_event" | "EventScreenNewMobile_event">;
    } | null | undefined;
  } | null | undefined;
};
export type EventScreenSettingsButtonUpdateMutation = {
  response: EventScreenSettingsButtonUpdateMutation$data;
  variables: EventScreenSettingsButtonUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateProvinceRegionCode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipPostalCode",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "geojson",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v14 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v15 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v16 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v17 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v21 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v14/*: any*/),
            (v15/*: any*/),
            (v21/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":100,\"w\":100})"
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v14/*: any*/),
        (v21/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":100,\"w\":100})"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v25 = [
  (v18/*: any*/),
  (v19/*: any*/),
  (v13/*: any*/),
  (v20/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v9/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v28 = [
  (v27/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventScreenSettingsButtonUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateEventPayload",
        "kind": "LinkedField",
        "name": "updateEventById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewMobile_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewDesktop_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventScreenSettingsButtonUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateEventPayload",
        "kind": "LinkedField",
        "name": "updateEventById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasVenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExternalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "seoVenue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sponsorshipDisplay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "membershipLevel",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "primaryPhoto",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "fields": [
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/)
                                ],
                                "kind": "ObjectValue",
                                "name": "transform"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "transformUrl",
                            "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                          }
                        ],
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isMe",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v20/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 368
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":368})"
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendee",
                "kind": "LinkedField",
                "name": "myAttendance",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendeeTicketPurchase",
                    "kind": "LinkedField",
                    "name": "ticketPurchase",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stripePaymentIntentStatus",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "venue",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entryInstructions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine2",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedAddress",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presenterFirstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presenterLastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "transform",
                                "value": {
                                  "dpr": 3,
                                  "fo": "auto",
                                  "h": 48,
                                  "w": 48
                                }
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "guestPresenterAvatarUrl",
                            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":48,\"w\":48})"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "presenter",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "ATTENDING_IN_PERSON",
                          "ATTENDING_VIRTUAL",
                          "WAITING_IN_PERSON",
                          "WAITING_VIRTUAL"
                        ]
                      }
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 8
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendeesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendee",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
              },
              {
                "alias": "attendingCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "ATTENDING_IN_PERSON",
                          "ATTENDING_VIRTUAL"
                        ]
                      }
                    }
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
              },
              {
                "alias": "waitingCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "WAITING_IN_PERSON",
                          "WAITING_VIRTUAL"
                        ]
                      }
                    }
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventTicketingTiersConnection",
                "kind": "LinkedField",
                "name": "eventTicketingTiers",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "51a26fa687033043eb07c146c0ff46b6504a66546ab2ef327ff9f8908542826b",
    "metadata": {},
    "name": "EventScreenSettingsButtonUpdateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6be0d53f0b752d00339c1993e4b06cb2";

export default node;
